import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Badge } from 'antd'

import { useInventory, useReports, useLatestPathname } from '../../modules'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import Patients from './Patients'
import Coding from './Coding'

const storeName = "Records"

let menu = []

const Records = () => {
    const [Inventory, store, requests] = useInventory(storeName)

    const history = useHistory()
    const pathname = useLatestPathname()

    const { user } = useSelector(state => state.application)

    const [Reports, reports] = useReports("records")
    
    useEffect(() => {
        menu = [
            {
                path: '',
                title: 'Dashboard'
            },
            {
                path: 'patients',
                title: 'Patients',
                component: Patients
            },
            {
                path: 'diagnoses',
                title: 'Diagnoses',
                submenu: [
                    {
                        path: 'outpatient',
                        title: 'Outpatient',
                        component: () => <Coding department="OutPatient" />
                    },
                    {
                        path: 'inpatient',
                        title: 'Inpatient',
                        component: () => <Coding department="InPatient" />
                    },
                    {
                        path: 'maternity',
                        title: 'Maternity',
                        component: () => <Coding department="Maternity" />
                    },
                    {
                        path: 'dental',
                        title: 'Dental',
                        component: () => <Coding department="Dental" />
                    },
                    {
                        path: 'eye-clinic',
                        title: 'Eye Clinic',
                        component: () => <Coding department="Eye" />
                    },
                    {
                        path: 'report',
                        title: 'Report'
                    }
                ]
            },
            {
                path: 'files',
                title: 'Files'
            },
            {
                path: 'inventory',
                title: "Inventory"
            },
            {
                path: 'reports',
                title: 'Reports',
                component: ({ path }) => <Reports reports={ reports } department="records" />
            },
        ]

        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[4] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory path={ path } storeName={ storeName } />
            }

        if (!pathname.current.startsWith("/app/records/patients")) history.push("/app/records/patients")

    }, [user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Records</p>
                <SideMenu namespace="records" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="records" menu={ menu } />
            </div>
        </div>
    )
}

export default Records